// extracted by mini-css-extract-plugin
export default {"card":"payoutCard_card__1ri+r"};